"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const reducers_1 = require("../../../reducers");
const actions_1 = require("../../../actions");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const getCampaignType_1 = require("../../utils/getCampaignType");
const editableCampaign_1 = require("../../../reducers/editableCampaign");
const PublishCampaignConfirmationDialog = ({ campaignId, device, formattedAutomatedEndDate, formattedDate, formattedTime, handleCloseOverviewModalDisplay, handlePublishCampaignPrompt, history, location, publishCampaign, trigger, }) => {
    const getDialogText = () => {
        let dialogText = '';
        if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
            if (!trigger.dateTime) {
                dialogText = 'Publishing this campaign will start delivering it immediately. Continue?';
            }
            else {
                const monthAndDay = formattedDate.toLocaleString('en-us', {
                    month: 'long',
                    day: 'numeric',
                });
                const displayScheduledTimezone = !!trigger.dateTime.timeZone
                    ? trigger.dateTime.timeZone
                    : `using the devices' local time zone`;
                dialogText = `Publishing this campaign will schedule it for delivery on ${monthAndDay} at ${formattedTime} ${displayScheduledTimezone}. Continue?`;
            }
        }
        if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
            const startDate = formattedDate.toLocaleString('en-us', {
                month: 'long',
                day: 'numeric',
            });
            const endDate = formattedAutomatedEndDate
                ? formattedAutomatedEndDate.toLocaleString('en-us', {
                    month: 'long',
                    day: 'numeric',
                })
                : null;
            dialogText = `After publishing this campaign, notifications will begin delivering to devices on ${startDate} ${endDate && startDate !== endDate ? `until ${endDate}` : ''}. Continue?`;
        }
        if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
            dialogText = `Publishing this campaign makes it elegible for delivery through the Rover API. Continue?`;
        }
        return dialogText;
    };
    const publish = () => {
        const campaignIdRegEx = new RegExp(`[\\&-]?campaignId=${campaignId}`);
        const search = location.search.replace(campaignIdRegEx, '');
        const pathname = location.pathname.replace('wizard/', '');
        publishCampaign(campaignId);
        handlePublishCampaignPrompt();
        handleCloseOverviewModalDisplay(history, `${pathname}${search}`);
    };
    return (React.createElement(src_1.Dialog, { buttonPrimaryText: "Cancel", buttonSecondaryText: "Publish", primaryOnClick: handlePublishCampaignPrompt, secondaryOnClick: publish, isOpen: true, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', dialogText: getDialogText() }));
};
const mapStateToProps = (state) => {
    return {
        trigger: reducers_1.getEditableCampaignTrigger(state),
        formattedTime: reducers_1.getEditableCampaignDisplayTime(state),
        formattedDate: editableCampaign_1.getFormatDate(state),
        formattedAutomatedEndDate: editableCampaign_1.getFormattedAutomatedEndDate(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        handleCloseOverviewModalDisplay: (history, path) => dispatch(actions_1.handleCloseOverviewModalDisplay(history, path)),
        publishCampaign: (campaignId) => {
            dispatch(actions_1.publishCampaign(campaignId));
        },
    };
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PublishCampaignConfirmationDialog));
